import { SkeletonsBlock } from "@/molecules/SkeletonsBlock"
import { IntroduceThroughModal } from "@/organisms/Drawers/components/IntroduceThrough"

import type { InnerCardProps } from "../../PackageVulnerabilityCards.types"

export const IntroducedThroughCard = (props: InnerCardProps) => {
  const { response, isLoading, t, tKey } = props

  if (isLoading || !response) {
    return <SkeletonsBlock />
  }

  const {
    codeRepoFindings,
    baseImageFindings = [],
    thirdPartyFindings = [],
    imageFindings = [],
    vmFindings = []
  } = response

  const defaultExpandedRowKeys = []
  if (codeRepoFindings.length > 0) {
    defaultExpandedRowKeys.push(codeRepoFindings[0].resource.id)
  } else if (baseImageFindings.length > 0) {
    defaultExpandedRowKeys.push(baseImageFindings[0].resource.id)
  } else if (thirdPartyFindings.length > 0) {
    defaultExpandedRowKeys.push(thirdPartyFindings[0].resource.id)
  } else if (imageFindings.length > 0) {
    defaultExpandedRowKeys.push(imageFindings[0].resource.id)
  }

  return (
    <IntroduceThroughModal
      drawer
      t={t}
      tKey={tKey}
      imageFindings={imageFindings}
      baseImageFindings={baseImageFindings}
      thirdPartyFindings={thirdPartyFindings}
      codeRepoFindings={codeRepoFindings}
      vmFindings={vmFindings}
      title={t(`${tKey}introducedThroughByResource`)}
      description={t(`${tKey}introducedThroughDescription`)}
      buttonText={t(`${tKey}allIntroducedThrought`)}
      defaultExpandedRowKeys={defaultExpandedRowKeys}
      showResolvedFindingsAlert={response?.showResolvedFindingsAlert || false}
    />
  )
}
